/**
 * Normalize profile image URLs for <img src> (protocol-relative, relative paths,
 * Google avatars served over http on an https page).
 */

function upgradeGoogleHttpToHttps(url) {
	const s = String(url || "").trim();
	if (!s.startsWith("http://")) return s;
	if (typeof window === "undefined" || window.location?.protocol !== "https:") return s;
	try {
		const u = new URL(s);
		const h = u.hostname.toLowerCase();
		if (
			h === "lh3.googleusercontent.com" ||
			h.endsWith(".googleusercontent.com") ||
			h === "googleusercontent.com"
		) {
			u.protocol = "https:";
			return u.href;
		}
	} catch {
		/* ignore */
	}
	return s;
}

export function normalizeAvatarSrc(url) {
	if (url == null) return "";
	let s = String(url).trim();
	if (!s) return "";
	if (s.startsWith("//")) s = `https:${s}`;
	else s = upgradeGoogleHttpToHttps(s);
	if (/^https?:\/\//i.test(s)) return s;
	if (s.startsWith("data:")) return s;
	if (s.startsWith("/")) {
		if (typeof window !== "undefined" && window.location?.origin) {
			try {
				return new URL(s, window.location.origin).href;
			} catch {
				return s;
			}
		}
		return s;
	}
	return s;
}

export function pickProfileImageUrl(user) {
	if (!user || typeof user !== "object") return "";
	const raw =
		user.profile_picture ||
		user.profilePicture ||
		user.picture ||
		user.photo_url ||
		user.photoUrl ||
		user.avatar_url ||
		user.avatar ||
		user.image ||
		user.profile_image ||
		"";
	return normalizeAvatarSrc(raw);
}

/** True when the URL should be rendered with an <img> (not initials / raw text). */
export function isAvatarImgSrc(url) {
	const n = normalizeAvatarSrc(url);
	return /^https?:\/\//i.test(n) || n.startsWith("data:");
}
